import { useSelector } from 'react-redux';
import { Route, useParams } from 'react-router-dom';
import { TracedRoutes } from '@comeon/error-reporter';
import styled from 'styled-components';
import useCasinoRoutes from '~/components/router/use-casino-routes';
import translate from '~/components/translation/translation-provider.js';
import breakpoint from '~/utils/style-utils.ts';
import { selectCasinoSubMenuItems } from '~/components/brand/ducks/selectors.js';
import NullLoader from '~/components/null-loader.js';

const Hero = styled.h2`
	display: none;
	align-items: center;
	color: var(--hero-font-color);
	font: var(--h1);
	padding: 0 24px;
	min-height: var(--heroHeight);
	${breakpoint.lg`
		display: flex;
	`}
`;

const SubMenuHero = ({ items }) => {
	const params = useParams();
	const submenu = items?.find(item => item.urlPath?.includes(params.submenu));
	return <Hero>{submenu?.name}</Hero>;
};

const RoutesHero = ({
	translations: { MOBILE_SEARCH_NAV, TAB_CASINO_JACKPOTS, CASINO_SORT_LOVED, MOBILE_RECENTLY_PLAYED_GAMES }
}) => {
	const subMenuItems = useSelector(selectCasinoSubMenuItems);
	const {
		ROUTE_CASINO_ALL_GAMES,
		ROUTE_CASINO_JACKPOT,
		ROUTE_CASINO_MY_GAMES_LOVED,
		ROUTE_CASINO_MY_GAMES_RECENT,
		ROUTE_CASINO_SEARCH,
		ROUTE_CASINO_SUBMENU,
		ROUTE_LIVE_CASINO_ALL_GAMES,
		ROUTE_LIVE_CASINO_MY_GAMES_LOVED,
		ROUTE_LIVE_CASINO_SEARCH,
		ROUTE_LIVE_CASINO_SUBMENU
	} = useCasinoRoutes();

	return (
		<TracedRoutes>
			{[ROUTE_CASINO_SEARCH, ROUTE_LIVE_CASINO_SEARCH, ROUTE_LIVE_CASINO_ALL_GAMES, ROUTE_CASINO_ALL_GAMES].map(
				path => (
					<Route path={`${path}/*`} key={path} element={<Hero>{MOBILE_SEARCH_NAV}</Hero>} />
				)
			)}
			<Route path={ROUTE_LIVE_CASINO_MY_GAMES_LOVED} element={<Hero>{CASINO_SORT_LOVED}</Hero>} />
			<Route path={ROUTE_CASINO_JACKPOT} element={<Hero>{TAB_CASINO_JACKPOTS}</Hero>} />
			<Route path={ROUTE_CASINO_MY_GAMES_LOVED} element={<Hero>{CASINO_SORT_LOVED}</Hero>} />
			<Route path={ROUTE_CASINO_MY_GAMES_RECENT} element={<Hero>{MOBILE_RECENTLY_PLAYED_GAMES}</Hero>} />
			<Route path={`${ROUTE_CASINO_SUBMENU}/:submenu`} element={<SubMenuHero items={subMenuItems?.casino} />} />
			<Route
				path={`${ROUTE_LIVE_CASINO_SUBMENU}/:submenu`}
				element={<SubMenuHero items={subMenuItems?.live_casino} />}
			/>
			<Route path="*" element={<NullLoader />} />
		</TracedRoutes>
	);
};
const textkeys = [
	'MOBILE_EXPLORE_BUTTON',
	'MOBILE_SEARCH_NAV',
	'TAB_CASINO_JACKPOTS',
	'CASINO_SORT_LOVED',
	'MOBILE_RECENTLY_PLAYED_GAMES'
];

export default translate(RoutesHero, textkeys);
